<template>
  <LazyHydrate v-bind="hydrationStrategy">
    <FooterThreeCols v-bind="$attrs" :blok="blok" :context="context">
      <template #col-1>
        <LinkList
          v-if="linkList.length"
          :blok="blok"
          :link-list="linkList[0]"
          :context="context"
        />
      </template>
      <template #col-2>
        <LinkList
          v-if="linkList.length > 1"
          :blok="blok"
          :link-list="linkList[1]"
          :context="context"
        />
      </template>
      <template #col-3>
        <LinkList
          v-if="linkList.length > 2"
          :blok="blok"
          :link-list="linkList[2]"
          :context="context"
        />
        <div
          v-if="blok.followIconsPosition === 'footer'"
          class="mt-4 flex space-x-3"
        >
          <template v-for="channel in sortedChannels" :key="channel.name">
            <SocialMediaLink v-if="channel.url" :channel="channel" />
          </template>
        </div>
      </template>
    </FooterThreeCols>
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import SocialMediaLink from '../components/SocialMediaLink.vue'
import LinkList from '../components/LinkList.vue'
import FooterThreeCols from './FooterThreeCols.vue'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const hydrationStrategy = computed(() => {
  return {
    onInteraction: ['focus'],
  }
})
const linkList = computed(() => {
  const list = []
  if (props.blok.firstLinkList.length) {
    list.push(props.blok.firstLinkList[0])
  }
  if (props.blok.secondLinkList.length) {
    list.push(props.blok.secondLinkList[0])
  }
  if (props.blok.thirdLinkList.length) {
    list.push(props.blok.thirdLinkList[0])
  }
  return list
})
const sortedChannels = computed(() => {
  return [...channels.value].sort((a, b) => a.order - b.order)
})
const channels = computed(() => {
  return [
    {
      name: 'facebook',
      order: +props.blok.facebookPosition || 0,
      url: props.blok.facebookUrl,
      label: 'Facebook',
    },
    {
      name: 'twitter',
      order: +props.blok.twitterPosition || 0,
      url: props.blok.twitterUrl,
      label: 'Twitter',
    },
    {
      name: 'linkedin',
      order: +props.blok.linkedinPosition || 0,
      url: props.blok.linkedinUrl,
      label: 'LinkedIn',
    },
    {
      name: 'instagram',
      order: +props.blok.instagramPosition || 0,
      url: props.blok.instagramUrl,
      label: 'Instagram',
    },
    {
      name: 'youtube',
      order: +props.blok.youtubePosition || 0,
      url: props.blok.youtubeUrl,
      label: 'Youtube',
    },
    {
      name: 'tiktok',
      order: +props.blok.tiktokPosition || 0,
      url: props.blok.tiktokUrl,
      label: 'Tiktok',
    },
  ]
})
</script>
